import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../../configureStore';

const selectUsersState = (state: RootState) => state.user;

const selectUser = createDraftSafeSelector(selectUsersState, (state) => state.user);

export { selectUsersState, selectUser };
